import React from 'react';
import '../css/ui/Button.scss';
import Grid from '../responsive/Grid';
import { resolveURL } from '../core/URLResolver';
import Router from '../router/Router';
import Link from '../css/ui/Link';

interface Props
{
	to?:string,
	link?:string,
	url?:string,
	border?:boolean,
	grid?:object,
	className?:string,
	onClick?:any,
	plain?:Boolean
}

export default class Button extends React.Component<Props>
{
	render()
	{
		let classes = [];
		if (this.props.grid) classes = classes.concat(Grid.parseBreakpoints(this.props.grid));
		if (this.props.border) classes.push('border');
		if (this.props.className) classes.push(this.props.className);
		if(!this.props.plain) classes.push('button');

		let link = null;
		if(this.props.to) link = this.props.to;
		else if(this.props.link) link = Router.getByID(this.props.link);
		console.log(this.props.link, link);
		let url = this.props.url;
		let props = {
			onClick: this.props.onClick,
			href: (url)?url:null,
			target: (this.props.url)?'_blank':null,
			className: classes.join(' '),
			to: link,
			link: link,
		}
		if(link)
		{
			return (
				<Link {...props}>
					{this.props.children}
				</Link>
			)
		}else
		{
			return (
				<a {...props}>
					{this.props.children}
				</a>
			)
		}
	}
}